module.exports = __webpack_public_path__ + "img/ennetix-xtend-status-chart.f6374a35.png";